import type { AppointmentLabel, Label } from '@features/appointment-labels/types';

import type { CalendarGroupByMode } from '../../store/slice';
import type { ViewMode } from '../../types';

export const OTHER_LANE_ID = '__other__';

export const getLabelLaneLabels = ({
  labels,
  viewMode,
  groupByMode,
  groupByLabelGroupId,
}: {
  labels: Label[];
  viewMode: ViewMode;
  groupByMode: CalendarGroupByMode;
  groupByLabelGroupId: string | null;
}): Label[] => {
  if (viewMode !== 'day' || groupByMode === 'off' || !groupByLabelGroupId) {
    return [];
  }

  const selected =
    groupByMode === 'group'
      ? labels.filter(label => label.label_group_id === groupByLabelGroupId)
      : labels.filter(label => label.label_id === groupByLabelGroupId);

  return [...selected].sort(
    (left, right) =>
      left.display_order - right.display_order || left.name.localeCompare(right.name),
  );
};

export const resolveLabelLaneId = (
  laneLabels: Label[],
  appointmentLabels: AppointmentLabel[] = [],
): string => {
  const appointmentLabelIds = new Set(appointmentLabels.map(label => label.label_id));
  return (
    laneLabels.find(label => appointmentLabelIds.has(label.label_id))?.label_id ?? OTHER_LANE_ID
  );
};
